import React from 'react'
import PropTypes from 'prop-types'

const FooterReportSigleForm = () => ({
  alignment: 'between',
  margin: [10, 30, 10, 0],
  table: {
    widths: [`50%`, `50%`],
    body: [
      [
        {
          text: 'ผู้รายงานกะ A \n1.ลงชื่อ................................ 2.ลงชื่อ...............................',
          alignment: 'center',
          border: [true, true, true, false],
        },
        {
          text: `ผู้รายงานกะ B \n1.ลงชื่อ................................ 2.ลงชื่อ............................... `,
          style: 'header',
          alignment: 'center',
          border: [true, true, true, false],
        },
      ],
      [
        {
          text: '    (.......................................)    (.......................................)  ',
          alignment: 'center',
          border: [true, false, true, false],
        },
        {
          text: '    (.......................................)    (.......................................)  ',
          alignment: 'center',
          border: [true, false, true, false],
        },
      ],
      [
        {
          text: 'หัวหน้างานกะ A ลงชื่อ.......................................',
          alignment: 'center',
          border: [true, false, true, false],
        },
        {
          text: 'หัวหน้างานกะ B ลงชื่อ.......................................',
          style: 'header',
          alignment: 'center',
          border: [true, false, true, false],
        },
      ],
      [
        {
          text: '    (.........................................................)   ',
          alignment: 'center',
          border: [true, false, true, true],
        },
        {
          text: '    (.........................................................)    ',
          alignment: 'center',
          border: [true, false, true, true],
        },
      ],
    ],
  },
  styles: {
    header: {
      fontSize: 10,
      bold: true,
      alignment: 'right',
    },
    header1: {
      fontSize: 14,
      bold: true,
    },
  },
})

FooterReportSigleForm.propTypes = {}

export default FooterReportSigleForm
